import { IonSegmentButton } from "@ionic/react";
import { FormattedMessage } from "react-intl";

export const TabButton: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => {
  return (
    <IonSegmentButton
      value={value}
      className="text-black flex-grow-0 hover:text-black-700 text-sm font-normal rounded-full normal-case tracking-normal overflow-hidden "
    >
      <FormattedMessage id={label} />
    </IonSegmentButton>
  );
};
